export default "__VITE_ASSET__DCE0G$Px__"